import WorthyApi from 'lib/api/worthyApi';
import rootStore from 'reducers';
import { showLoader, hideLoader } from 'actions/loader';
import { ado } from 'actions/ado';
import { getDateTimeDescription, retriable } from '../helpers/ApplicationHelper';
import moment from 'moment';

export const ITEM_APPOINTMENT_DETAILS = Symbol('ITEM_APPOINTMENT_DETAILS');
export const PAYMENT_DETAILS = Symbol('PAYMENT_DETAILS');
export const SCHEDULE_APPOINTMENT = Symbol('SCHEDULE_APPOINTMENT');
export const LAST_PRE_DELIVERED_ITEM = Symbol('LAST_PRE_DELIVERED_ITEM');

export function getPaymentDetails(itemId = null) {
    rootStore.dispatch(showLoader());

    let request =
        WorthyApi.getPaymentDetails(itemId)
            .then((res) => {
                rootStore.dispatch(hideLoader());
                return res;
            })
            .catch((error) => {
                rootStore.dispatch(hideLoader());
                throw error;
            });

    return {
        type:       PAYMENT_DETAILS,
        payload:    request
    }
}

export function savePaymentDetails(data) {
    rootStore.dispatch(showLoader());

    let request =
        WorthyApi.savePaymentDetails(data)
            .then((res) => {
                rootStore.dispatch(hideLoader());
                return res;
            })
            .catch((error) => {
                rootStore.dispatch(hideLoader());
                throw error;
            });

    return {
        type:       null,
        payload:    request
    }
}

export function updateMissingDetails(data) {
    rootStore.dispatch(showLoader());

    let request =
        WorthyApi.updateMissingDetails(data)
            .then((res) => {
                // rootStore.dispatch(session(res.data.user));
                rootStore.dispatch(hideLoader());
                setTimeout(() => {
                    rootStore.dispatch(ado());
                }, 2000);
                return res;
            })
            .catch((error) => {
                rootStore.dispatch(hideLoader());
                throw error;
            });

    return {
        type:       null,
        payload:    request
    }
}

export function scheduleAppointment(data) {
    rootStore.dispatch(showLoader());

    let request =
        WorthyApi.scheduleAppointment(data)
            .then((res) => {
                rootStore.dispatch(hideLoader());
                return res;
            })
            .catch((error) => {
                rootStore.dispatch(hideLoader());
                throw error;
            });

    return {
        type:    SCHEDULE_APPOINTMENT,
        payload: request
    };
}

export async function appointmentsItemDetails(eventId, itemId) {

    const action = {
        type: ITEM_APPOINTMENT_DETAILS,
        payload: {}
    };
    try {
        let res;
        let dateTime;

        if (!eventId) {
            res = await retriable(WorthyApi.getItemAppointment, itemId, 2);
            dateTime = _.get(res, 'data.data[0].scheduled_time');
        } else {
            res = await WorthyApi.getCalendlyData(eventId);
            dateTime = _.get(res, 'data.resource.start_time');
        }

        if (dateTime) {
            const scheduledTime = getDateTimeDescription(moment(dateTime), true);
            const currDateTime = new Date().toISOString();
            if (currDateTime > dateTime) {
                return action;
            }

            _.set(action, 'payload.scheduledTime', scheduledTime);
        }

        return action;
    } catch (err) {
        return action;
    }
}

export function getLastItemPreDelivered(userId) {

    let request = WorthyApi.getLastPreDeliveredItem(userId);

  return {
    type:       LAST_PRE_DELIVERED_ITEM,
    payload:    request
  };
}
